export default __webpack_public_path__ + "static/media/road-bg.2fcbb60a.png";